export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/b552ae94a3baa9664c4076d726380c66.svg";